export default __webpack_public_path__ + "static/media/phone.d4900ffd.png";